// @ts-nocheck
import React from 'react';
import styles from './index.scss'
import { Swiper } from 'antd-mobile'
import Service, { IDpBusinessCommodityService } from './component/service' // 服务配置
import Toolbar, { IDpToolbarPropsType } from './component/toolbar' // 页脚客服电话等
import ToolSubmit, { IDpBusinessCommodityToolBar } from './component/toolSubmit' // 提交，包含价格
import RichView, { IDpBusinessCommodityRichView } from './component/richView' // 富文本
import Goods, { IDpBusinessCommodityGoods } from './component/goods' // 商品卡片
import Part from './component/part' // 服务时间等块级
import Settlement, { IDpBusinessCommoditySettlement } from './component/settlement' // 结算信息
import amountPriceMap, { IDpBusinessCommodityPrice } from './component/price' // 价格
import Base, { IDpBusinessCommodityBase } from './component/base' // 商品商品基础部分
import AddCommodity, { IDpBusinessCommodityAddCommodity } from './component/addCommodity' // 这是加项
import Notice, { IDpBusinessCommodityNotice } from './component/notice' // 公告
import Result, { IDpBusinessCommodityResult } from './component/result' // 结果

interface IDpBusinessCommodity {
  containerStyles?: React.CSSProperties
  styles?: React.CSSProperties
  children: any
  swiperImgStyle?: React.CSSProperties
  images?: string[]
  hasImagesPlaceholder?: boolean
}

const DpBusinessCommodity = (props: IDpBusinessCommodity) => {
  const { children } = props;
  return (
    <div className={styles["dp-business-commodity"]} style={props?.containerStyles}>
      {
        props?.images?.length > 0 ? 
          <Swiper
            indicator={(total, current) => (
              <div className={styles["dp-business-commodity--customIndicator"]}>
                {`${current + 1} / ${total}`}
              </div>
            )}
          >
            {props?.images?.map?.((url, index) => (
              <Swiper.Item key={index}>
                <img src={url} className={styles["dp-business-commodity--image"]} />
              </Swiper.Item>
            ))}
          </Swiper>
        : <>
          {
            props?.hasImagesPlaceholder ? 
              <div className={styles["dp-business-commodity--image"]}></div>:
              undefined
          }
        </>
      }
      <main className={styles["dp-business-commodity--container"]} style={props?.styles}>{children}</main>
    </div>
  )
};

DpBusinessCommodity.Toolbar = Toolbar as React.FC<IDpToolbarPropsType>
DpBusinessCommodity.Base = Base as React.FC<IDpBusinessCommodityBase>
DpBusinessCommodity.RichView = RichView as React.FC<IDpBusinessCommodityRichView>
DpBusinessCommodity.Service = Service as React.FC<IDpBusinessCommodityService> // Sass服务商品的服务设置
DpBusinessCommodity.Goods = Goods as React.FC<IDpBusinessCommodityGoods> // 商品卡片
DpBusinessCommodity.Settlement = Settlement as React.FC<IDpBusinessCommoditySettlement> // 结算信息
DpBusinessCommodity.Part = Part as any // 
DpBusinessCommodity.ToolSubmit = ToolSubmit as React.FC<IDpBusinessCommodityToolBar>
DpBusinessCommodity.AmountPriceMap = amountPriceMap as React.FC<IDpBusinessCommodityPrice> & ReactElement<any, any>
DpBusinessCommodity.AddCommodity = AddCommodity as React.FC<IDpBusinessCommodityAddCommodity>
DpBusinessCommodity.Notice = Notice as React.FC<IDpBusinessCommodityNotice>
DpBusinessCommodity.Result = Result as React.FC<IDpBusinessCommodityResult>
export default DpBusinessCommodity;
